import { render, staticRenderFns } from "./AnimatedNumbershape.vue?vue&type=template&id=013016c6&"
import script from "./AnimatedNumbershape.vue?vue&type=script&lang=js&"
export * from "./AnimatedNumbershape.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports